import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './SectionHeader';
import { CheckCircle2Icon } from 'lucide-react';
const tags = ['Anamnesis', 'Árbol de decisión', 'Informes', 'Protocolos', 'Devolución', 'Articulación', 'Consultorio', 'Honorarios', 'Cancelaciones', 'Seguimiento', 'Redes', 'Derivaciones'];
const skills = ['Anamnesis estructurada', 'Selección de instrumentos', 'Redacción de informes', 'Devolución diagnóstica', 'Articulación escolar', 'Coordinación interdisciplinaria', 'Gestión de honorarios', 'Política de cancelaciones', 'Contenido para Instagram', 'Red de derivaciones'];
export function SystemOverview() {
  return <section className="py-12 md:py-20 px-4 md:px-8 bg-white" data-id="element-253">
      <div className="max-w-5xl mx-auto" data-id="element-254">
        <SectionHeader eyebrow="SISTEMA N°1 EN ARGENTINA" title="8 Tomos + 3 Bonos · Todo resuelto" className="mb-8 md:mb-12" data-id="element-255" />

        <div className="bg-cream p-6 md:p-12 rounded-3xl border border-teal-900/10 shadow-sm mb-8 md:mb-12" data-id="element-256">
          <div className="flex flex-row items-center justify-center gap-6 md:gap-12 mb-6 md:mb-10 pb-6 md:pb-10 border-b border-teal-900/10" data-id="element-257">
            <div className="text-center" data-id="element-258">
              <span className="block text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-1" data-id="element-259">
                +40
              </span>
              <span className="text-[10px] md:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-260">
                herramientas
              </span>
            </div>
            <div className="w-px h-12 md:h-16 bg-teal-900/10" data-id="element-261"></div>
            <div className="text-center" data-id="element-262">
              <span className="block text-3xl md:text-4xl font-serif font-bold text-teal-900 mb-1" data-id="element-263">
                80
              </span>
              <span className="text-[10px] md:text-sm font-bold text-slate-500 uppercase tracking-wider" data-id="element-264">
                frases clínicas
              </span>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8" data-id="element-265">
            {tags.map((tag, i) => <span key={i} className="bg-white border border-teal-100 text-teal-800 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-medium shadow-sm hover:border-teal-400 hover:bg-teal-50 transition-colors cursor-default" data-id="element-266">
                {tag}
              </span>)}
          </div>

          <p className="text-center text-sm md:text-base text-slate-600 font-medium" data-id="element-267">
            Funciona desde hoy en tu consultorio, en tu tablet o impreso en
            papel.
          </p>
        </div>

        <div data-id="element-268">
          <h3 className="text-xl md:text-2xl font-serif font-bold text-teal-900 mb-5 md:mb-8 text-center" data-id="element-269">
            Habilidades incluidas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2.5 md:gap-y-4 max-w-3xl mx-auto" data-id="element-270">
            {skills.map((skill, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: i * 0.05
          }} className="flex items-center gap-3" data-id="element-271">
                <CheckCircle2Icon className="text-teal-600 shrink-0" size={18} data-id="element-272" />
                <span className="text-sm md:text-base text-slate-700 font-medium" data-id="element-273">
                  {skill}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}